// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {createAction} from 'redux-actions';

export const resetOnStartOver = createAction('RESET_ON_START_OVER');
export const resetStoreOnSearch = createAction('RESET_STORE_ON_SEARCH');
